import * as React from 'react'

import { Routes } from '@thg-commerce/enterprise-core'
import { Widget } from '@thg-commerce/enterprise-network/src/generated/graphql'
import { WidgetRenderer } from '@thg-commerce/enterprise-widgets'

import { RecentlyViewed } from './ProductRecList/RecentlyViewed'
import {
  BasketIcon,
  Container,
  ContentWrapper,
  ContinueShoppingLink,
  Subtitle,
  Title,
} from './styles'

interface BasketEmptyProps {
  i18nText: {
    title: string
    subtitle: string
    continueShopping: string
  }
  widgets?: Omit<Widget, 'query'>[]
  showRecent?: boolean
}

export const Empty = ({ i18nText, widgets, showRecent }: BasketEmptyProps) => {
  return (
    <Container data-testid="basket-empty" enableRecs={showRecent}>
      <ContentWrapper>
        <BasketIcon />
        <Title>{i18nText.title}</Title>
        <Subtitle>{i18nText.subtitle}</Subtitle>
        <ContinueShoppingLink
          href={Routes.HomePage}
          ariaLabel={i18nText.continueShopping}
          renderedAs="a"
        >
          {i18nText.continueShopping}
        </ContinueShoppingLink>
      </ContentWrapper>
      <WidgetRenderer widgets={widgets || []} path={Routes.Basket} />
      {showRecent && <RecentlyViewed />}
    </Container>
  )
}
